import React from 'react';
import { DOMNode } from 'html-react-parser';
import useRenderGlossary from '../../hooks/use-render-glossary';
import ResponsiveDialog from '../dialog';

function Glossary({ domNode }: { domNode: DOMNode }) {
  const glossaryData = useRenderGlossary(domNode);

  if (!glossaryData) {
    return null;
  }

  return (
    <ResponsiveDialog
      title={glossaryData.title}
      description={glossaryData.noteString}
      key={`${glossaryData.title}`}
      isTerm={glossaryData.isTerm}
    />
  );
}

export default Glossary;
